<template>
  <div>
    <ExpansionPanel
      v-model="panel"
      :title="'Desconto'"
      :icon="$icons.box"
      readonly
    >
      <v-form v-model="validFormFreight" ref="validFormFreight" lazy-validation>
        <Row>
          <Col :cols="classCols">
            <TextFieldMoney
              v-model="order.total_discount_value"
              :placeholder="'Desconto Geral'"
              :label="'Desconto Geral'"
              @input="updateInfosOrderSale"
              :readonly="true"
            />
          </Col>
          <Col :cols="classCols">
            <div class="d-flex">
              <Button
                label="Desc. Geral"
                color="primary"
                rounded
                @click="openDialog('dialogOrderEditModalModal')"
                :disabled="disabledButtons"
                class="mr-2"
              />
              <Button
                label="Zerar Desc."
                color="secondary"
                rounded
                @click="openDialog('dialogConfirmation')"
                :disabled="disabledButtons"
              />
            </div>
          </Col>
        </Row>
      </v-form>
    </ExpansionPanel>

    <Dialog :dialog="dialogOrderEditModalModal" :max-width="600">
      <OrderDiscountEditModal
        slot="content"
        @changeDiscount="changeDiscount"
        @close="dialogOrderEditModalModal = false"
      />
    </Dialog>

    <DialogConfirmation
      :dialog="dialogConfirmation"
      title="Zerar descontos"
      message="Deseja realmente zerar todos os descontos?"
      @noActionDialogConfirmation="dialogConfirmation = false"
      @yesActionDialogConfirmation="resetDiscount"
    />
  </div>
</template>

<script>
import {
  Row,
  Col,
  ExpansionPanel,
  TextFieldMoney,
  Button,
  Dialog,
} from '@/components/vuetify';
import DialogConfirmation from '@/components/DialogConfirmation';
import { required } from '@/utils/rules';
import UpdateInfosOrderSaleMixin from '../mixins/UpdateInfosOrderSaleMixin';
import OrderDiscountEditModal from './OrderDiscountEditModal';

export default {
  name: 'OrderFreight',
  components: {
    ExpansionPanel,
    Row,
    Col,
    TextFieldMoney,
    Button,
    OrderDiscountEditModal,
    Dialog,
    DialogConfirmation,
  },
  inject: ['propsComponents'],
  mixins: [UpdateInfosOrderSaleMixin],
  data() {
    return {
      panel: [0],
      validFormFreight: false,
      rules: {
        required: required,
      },
      dialogOrderEditModalModal: false,
      dialogConfirmation: false,
    };
  },
  computed: {
    total_value_individual_discount() {
      return this.order.items
        .filter((item) => item.is_individual_discount)
        .reduce((acc, item) => acc + parseFloat(item.discount_value), 0);
    },
    disabledButtons() {
      return this.order.is_delivered;
    },
  },
  methods: {
    openDialog(dialog) {
      this[dialog] = true;
    },
    changeDiscount(discount) {
      this.order.total_discount_value = parseFloat(discount);
      this.order.total_order =
        parseFloat(this.order.total_products) - parseFloat(discount);

      this.updateInfosOrderSale();
      this.dialogOrderEditModalModal = false;
    },
    resetDiscount() {
      this.order.total_discount_value = 0;
      this.order.total_order = parseFloat(this.order.total_products);

      this.dialogConfirmation = false;
      this.updateInfosOrderSale();
    },
  },
};
</script>
